import { render, staticRenderFns } from "./bjqnzzxy.vue?vue&type=template&id=14fef446&scoped=true&"
import script from "./bjqnzzxy.vue?vue&type=script&lang=js&"
export * from "./bjqnzzxy.vue?vue&type=script&lang=js&"
import style0 from "./bjqnzzxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bjqnzzxy.vue?vue&type=style&index=1&id=14fef446&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fef446",
  null
  
)

export default component.exports